import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function MidPageCTA() {
  return <section className="w-full bg-[#faf7f2] py-12 px-4" data-id="element-239">
      <div className="max-w-2xl mx-auto" data-id="element-240">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-[#0f172a] rounded-2xl p-8 md:p-10 text-center relative overflow-hidden" data-id="element-241">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[300px] h-[300px] bg-[#5b8a7a] opacity-10 blur-[80px] rounded-full pointer-events-none" data-id="element-242" />

          <p className="text-[#cbd5e1] text-lg mb-4 relative z-10" data-id="element-243">
            ¿Ya sabes que lo necesitas?
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 relative z-10" data-id="element-244">
            <motion.a href="https://www.betterbysteps.com/cart/44204964905053:1" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="inline-flex bg-[#e8856c] text-white px-8 py-4 rounded-xl text-base font-bold shadow-[0_0_20px_rgba(232,133,108,0.3)] hover:shadow-[0_0_30px_rgba(232,133,108,0.5)] transition-all items-center gap-2 no-underline" data-id="element-245">
              Obtener Guion Ahora <ArrowRight className="w-5 h-5" data-id="element-246" />
            </motion.a>
            <span className="text-[#64748b] text-sm" data-id="element-247">
              <span className="line-through" data-id="element-248">$19</span> $6.36 · Precio de
              lanzamiento
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}